import App from "../../../vendor_core/core/src/App";
import GameEvents from "../../../vendor_core/core/src/const/GameEvents";
import GameModel from "../../../vendor_core/core/src/model/GameModel";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import SpinResultState from "../../../vendor_core/core/src/states/SpinResultState";
import BURReelsModel from "../models/BURReelsModel";
import BURSpinModel from "../models/BURSpinModel";

export default class BURSpinResultState extends SpinResultState {
    public enter(): void {
        super.enter();
        // SoundController.playSound("reel_stop_normal");
        const fsIndex = BURSpinModel.current_free_spin_index;
        if (fsIndex !== -1) {
            BURSpinModel.setCurrentFreeSpinIndex(fsIndex + 1);
        }
    }
    protected stopReels(delay = 0) {
        GameModel.setSpinDelay(0);
        // TO DO => This must be remove from stop reels func !!!
        this.setUIStateOnReelStop();

        App.dispatcher.once(
            GameEvents.ALL_REELS_STOPPED,
            () => {
                // SoundController.playSound(SoundVars.EFFECT_REEL_STOP);
                BURReelsModel.reels.removeEnergyFrames().then(() => {
                    this.exit();
                });
            },
            this
        );

        let reels = Array.from(Array(BURReelsModel.reels.reels.length).keys());
        let result = SpinModel.getStopSymbolsForReels(reels);
        BURReelsModel.reels.stop(result, delay);
    }
}
